import styled, { css } from 'styled-components';
import { InfoIconStatusTypes } from 'Types/enums';

/* --------------- SUB PAGE HEADER ------------------ */

const SubPageHeader = styled.div`
  font-size: var(--core-font-size-normal);
  font-weight: 600;
  color: var(--user-content-sub-title);
  margin-bottom: 20px;
`

/* --------------- PADER --------------------------- */

const Pader = styled.div<{$padding: string}>`
  width: 100%;
  padding: ${
    props =>  props.$padding 
                ? props.$padding
                : "0"
  };
`

/* --------------- SPACER --------------------------- */

const Spacer = styled.div<{height: string}>`
  width: 100%;
  height: ${
    props =>  props.height 
                ? props.height + "px" 
                : "10px"
  };
`

/* --------------- SUB PAGE SEPARATOR --------------- */

const SubPageSeparator = styled.div`
  width: 100%;
  height: 1px;
  background-color: #505A7D4D;
`

/* --------------- SPIN ----------------------------- */

const SpinWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100%;
  height: max-content;
`

const BigSpinner = styled.div`

  >div >div >.itd-spin-spinner {
      
    width: 32px;
    height: 32px;
    margin-top: -16px;
    margin-left: -16px;

    >div>div {
      border-color: #1D2649 transparent transparent;
    }

  }

`

const DefaultSpinner = styled.div`

  >div >.itd-spin-spinner {
      
    width: 40px;
    height: 40px;
    margin-top: -20px;
    margin-left: -20px; 

    >div>div {
      border-color: #1D2649 transparent transparent;
    }

  }

`

/* --------------- DEFAULT HEIGHT ------------------- */

const DefaultHeight = styled.div<{$minHeight: string}>`
  min-height: ${
    props =>  props.$minHeight 
                ? props.$minHeight
                : "400px"
  };
`

const LoadingDefaultHeight = styled(DefaultHeight)`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Loading = styled.div`

`

/* --------------- COLUMN --------------------------- */

const Col = styled.div<{col: string}>`
  grid-column: ${props => `span ${props.col}/auto`};
  width: 100%;
  `

/* --------------- GLOBAL CONTENT --------------------------- */

const ContentWrapper = styled.div<{$noMargin?:boolean}>`
  margin-top: ${props => props.$noMargin ? "0" : "94px"};
  display: flex;
  justify-content: center;
`

const ContentBody = styled.div`

  //min-width: 1000px;
  max-width: 1320px;
  width: 100%;

  margin: 0 50px;

  @media (max-width: 1024px) {
    margin: 0;
    padding: 0 12px;
  }

  display: flex;
  flex-direction: column;
  gap: 30px;

  table, .p-2 {
    width: 100%;
  }

`

/* --------------- ERROR --------------------------- */

const ErrorMessage = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #ab1212;
  margin-top: 10px;
`

/* --------------- MODAL --------------------------- */
const ModalWrapper = styled.div`
  
  display: flex;
  flex-direction: column;
  height: max-content;

  color: #4b5675;
  font-size: 14px;
  line-height: 18px;

`

const ModalTitle = styled.div<{
  $gap?:string,
  $align?:string,
  $justify?:string,
  $direction?:string,
}>`

  padding         : 30px 20px 25px;
  border-bottom   : 1px solid #f1f1f4;

  display         : flex;
  justify-content : ${props => props.$justify ? props.$justify : "flex-start"};
  align-items     : ${props => props.$align ? props.$align : "flex-start"};
  flex-direction  : ${props => props.$direction ? props.$direction : "column"};
  gap             : ${props => props.$gap ? props.$gap : "10px"};

  >span {
    font-size   : 18px;
    font-weight : 600;
    color       : #071437;
  }

`

const ModalTitleWithButton = styled.div<{
  $gap?:string
}>`

  padding: 0px 0px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  gap: ${props => props.$gap ? props.$gap : "10px"};
  height: 44px;
  min-height: 44px;

  >span {
    font-size: 18px;
    font-weight: 600;
    color: #071437;
  }

`

const ModalSubTitle = styled.div`

  margin-bottom: 20px;

  span {
    font-size: 16px;
    font-weight: 600;
    color: #071437;
  }

`

const ModalContent = styled.div`

  padding: 40px 60px;

`

const SimpleModalContent = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  color: #252f4a;
`

/* --------------- HUGE ALERT --------------------------- */

const HugeAlert = styled.div<{
  $type:string
}>`

  .icon {
    //margin-top: -5px;
  }

  background-color: #fff8dd;
  padding: 25px;
  border-radius: 6px;
  border: 1px dashed #f6c000;

  display: flex;
  align-items: flex-start;
  gap: 10px;

  >span, >div >div div>span {
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
    color: #4B5675;
  }

  >div {

    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    grid-gap: 20px;
    width: 100%;

    >div {

      display: flex;
      flex-direction: column;
      gap: 8px;

    }

  }

  ${props => {

    if ( props.$type === "pending" ) { 
      return css`
        background-color: #f3f3f3;
        border-color: #d9d9d9;

        .icon>span {
          color: #757575;
        }

        >div >div {
          h3>span {
            color: #071437;
          }
          div>span {
            color: #4b5675;
          }
        }

      `
    }

    if ( props.$type === "success" ) { 
      return css`
        background-color: #dfffea;
        border-color: #17c653;

        .icon>span {
          color: #17c653;
        }

        >div >div {
          h3>span {
            color: #071437;
          }
          div>span {
            color: #4b5675;
          }
        }

      `
    }

    if ( props.$type === "info" ) { 
      return css`
        background-color: #e9f3ff;
        border-color: #1b84ff;

        .icon>span {
          color: #1b84ff;
        }

        >div >div {
          h3>span {
            color: #071437;
          }
          div>span {
            color: #4b5675;
          }
        }

      `
    }

    if ( props.$type === "warning" ) { 
      return css`
        background-color: #fff8dd;
        border-color: #f6c000;

        .icon>span {
          color: #f6c000;
        }

        >div >div {
          h3>span {
            color: #071437;
          }
          div>span {
            color: #4b5675;
          }
        }

      `
    }

    if ( props.$type === "error" ) { 
      return css`
        background-color: #f9eded;
        border-color: #d9a4a4;

        .icon>span {
          color: #ab1212;
        }

        >div >div {
          h3>span {
            color: #071437;
          }
          div>span {
            color: #4b5675;
          }
        }

      `
    }

  }}

`

/* --------------- RADIO GROUP --------------------------- */

const FilterRadioGroup = styled.div`

  .itd-radio-label {

    .itd-radio-default-button {
      background: #ececec;
      border: 1px solid transparent;
      height: 34px;
      transition: all 0.3s ease;
      &:hover {
        border: 1px solid transparent!important;
        background: #e9e9e9;
      }
    }

    &.itd-radio-label-selected {
      .itd-radio-default-button {
        background: #1b84ff;
        border: 1px solid transparent;
        .itd-radio-content span {
          color: #ffffff!important;
        }
      }
    }

    }

`

/* --------------- STATUS TAG ----------------------------- */

const getStatusBackgroundByVariant = (variant:InfoIconStatusTypes) => {
  if ( variant === InfoIconStatusTypes.ACTIVE )   return "#64f7ab";
  if ( variant === InfoIconStatusTypes.PASSIVE )  return "#f1f1f199";
  if ( variant === InfoIconStatusTypes.REGULAR )  return "#e9f3ff";
}

const StatusTag = styled.div<{
  $variant: InfoIconStatusTypes
}>`
  display: flex;
  align-items: center;
  gap: 3px;
  background-color: ${props => getStatusBackgroundByVariant(props.$variant)};
  border-radius: 20px;
  padding: 2px 8px;

  >span:nth-child(2) {
    font-size: 12px;
    font-weight: 600;
  }
`

/* --------------- BOX ----------------------------- */

const Box = styled.div<{
  $hideBorder?  : boolean;
  $padding?     : number | string;
  $margin?      : number | string;
  $gap?         : number;
}>`
  outline       : ${({ $hideBorder }) => $hideBorder ? "none" : "1px solid #efefef"};
  padding       : ${({ $padding }) => $padding ? typeof $padding === "number" ? `${$padding}px` : $padding : "15px"};
  border-radius : ${({ $hideBorder }) => $hideBorder ? "0" : "6px"};
  margin        : ${({ $margin }) => $margin ? typeof $margin === "number" ? `${$margin}px` : $margin : "0"};

  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap ? `${$gap}px` : "15px"};
`

export { 
  Col, 
  SubPageHeader, 
  SpinWrapper, 
  DefaultSpinner,
  Pader, 
  Spacer, 
  SubPageSeparator, 
  DefaultHeight, 
  BigSpinner,
  LoadingDefaultHeight, 
  ContentWrapper,
  ContentBody,
  HugeAlert,
  ModalWrapper,
  ModalTitle,
  ModalTitleWithButton,
  ModalSubTitle,
  ModalContent,
  SimpleModalContent,
  Loading,
  FilterRadioGroup,
  Box,
  StatusTag,
 ErrorMessage
};